// Единый источник контактов и названий для шапки, подвала, главной и выбора сайта.
// Значения взяты с действующих сайтов (contacts.vue, Footer.vue, App.vue).
export const SITES = {
  abaata: {
    key: 'abaata',
    name: 'Абаата',
    place: 'Гагра',
    tagline: 'Исторический курорт у моря на территории Гагрской крепости',
    phone: '8 940 963 27 99',
    tel: '+79409632799',
    address: 'Абхазия, Гагра, пр-т Владислава Ардзинба, 115, крепость Абаата',
    email: 'reservation@abaata.ru',
    whatsapp: 'https://wa.me/79409357241',
    telegram: 'https://t.me/Hotel_Abaata',
    vk: 'https://vk.com/hotel_abaata',
    instagram: 'https://www.instagram.com/hotel_abaata/',
    facebook: 'https://www.facebook.com/critpr'
  },
  amari: {
    key: 'amari',
    name: 'Amari',
    place: 'Гагра',
    tagline: 'Новый современный бутик-отель класса делюкс на первой береговой линии',
    phone: '8 940 717 25 55',
    tel: '+79407172555',
    address: 'Абхазия, Гагра, улица Валентины Терешковой, 9/1',
    email: 'amari.hotel@yandex.ru',
    whatsapp: 'https://wa.me/79407172555',
    telegram: 'https://t.me/amarihotelgagra',
    vk: '',
    instagram: 'https://www.instagram.com/amari_hotel'
  },
  pitsunda: {
    key: 'pitsunda',
    name: 'Абаата',
    place: 'Пицунда',
    tagline: 'Новый отель у моря в окружении природного ландшафта',
    phone: '+7 (940) 951-91-29',
    tel: '+79409519129',
    address: 'Абхазия, Пицунда, ул. Фабричная, 5Б',
    email: '',
    whatsapp: '',
    telegram: '',
    vk: '',
    instagram: ''
  }
}

// Пункты меню (ссылки без префикса сайта)
export const MENUS = {
  abaata: [
    {
      link: '/about/',
      name: 'О комплексе',
      child: [
        { link: '/about/', name: 'О комплексе' },
        { link: '/about/gallery/', name: 'Галерея' },
        { link: '/about/contacts/', name: 'Контакты' },
        { link: '/about/web-cams/', name: 'Веб камеры' }
      ]
    },
    {
      link: '/offers/',
      name: 'Размещение',
      child: [
        { link: '/offers/3', name: 'Новые корпуса' },
        { link: '/offers/1', name: 'Корпус «Шале»' },
        { link: '/offer/15', name: 'VIP Вилла' }
      ]
    },
    {
      link: '/restaurants/',
      name: 'Рестораны',
      child: [
        { link: '/restaurant/50', name: 'Ресторан «Абаата»' },
        { link: '/restaurant/66', name: 'Кафе «Чайхона Абаата»' },
        { link: '/restaurant/67', name: 'Пляжный бар' },
        { link: '/restaurant/37036', name: 'Le Bistro Abaata' }
      ]
    },
    {
      link: '/services/',
      name: 'Развлечения',
      child: [
        { link: '/service/16', name: 'Бассейн' },
        { link: '/service/37028', name: 'SPA' },
        { link: '/service/264', name: 'Русская баня' },
        { link: '/service/35789', name: 'Бильярд' },
        { link: '/service/79', name: 'Тренажерный зал' },
        { link: '/service/20', name: 'Теннисный корт' },
        { link: '/service/18', name: 'Массаж' },
        { link: '/service/19', name: 'Трансфер' },
        { link: '/service/42', name: 'Экскурсии' }
      ]
    },
    { link: '/price', name: 'Цены' },
    { link: '/about/contacts/', name: 'Контакты' }
  ],
  amari: [
    { link: '/offers/', name: 'Размещение' },
    {
      link: '/services/',
      name: 'Развлечения',
      child: [
        { link: '/service/37042', name: 'Ресторан' },
        { link: '/service/37043', name: 'SPA' },
        { link: '/service/37044', name: 'Открытый бассейн' },
        { link: '/service/37045', name: 'Салон' },
        { link: '/service/37046', name: 'Тренажерный зал' },
        { link: '/service/37048', name: 'Roof bar' }
      ]
    },
    { link: '/price', name: 'Цены' },
    { link: '/about/contacts/', name: 'Контакты' }
  ],
  pitsunda: [
    { link: '/offers/', name: 'Размещение' },
    { link: '/services/', name: 'Развлечения' },
    { link: '/price', name: 'Цены' },
    { link: '/about/contacts/', name: 'Контакты' }
  ]
}

// в коде исторически встречается написание picunda
export function siteInfo (site) {
  return SITES[site === 'picunda' ? 'pitsunda' : site] || SITES.abaata
}
